/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NeedStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const NeedStatus = {
    NUMBER_0: 0 as NeedStatus,
    NUMBER_1: 1 as NeedStatus,
    NUMBER_2: 2 as NeedStatus,
    NUMBER_3: 3 as NeedStatus,
    NUMBER_4: 4 as NeedStatus,
    NUMBER_5: 5 as NeedStatus,
    NUMBER_6: 6 as NeedStatus,
    NUMBER_7: 7 as NeedStatus,
    NUMBER_8: 8 as NeedStatus,
    NUMBER_9: 9 as NeedStatus,
    NUMBER_10: 10 as NeedStatus,
    NUMBER_11: 11 as NeedStatus,
    NUMBER_12: 12 as NeedStatus
};

